import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate, formatTime } from "../../../../constants/helper";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { ShowTableCOA } from "../../../../components/ShowTable";
import { FetchErrorHandling } from "../../../../components/FetchErrorHandling";
import {
  SearchBar,
  Loader,
  ButtonModifier,
  ScrollToTop,
} from "../../../../components";
import {
  Box,
  TextField,
  Typography,
  Divider,
  Pagination,
  Button,
  ButtonGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import { Col, Row, Form } from "react-bootstrap";

const TampilCOA = () => {
  const { user, setting, dispatch } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { screenSize } = useStateContext();

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const [isFetchError, setIsFetchError] = useState(false);
  const [isCOAExist, setIsCOAExist] = useState(false);
  const [kodeCOA, setKodeCOA] = useState("");
  const [namaCOA, setNamaCOA] = useState("");
  const [jenisCOA, setJenisCOA] = useState("");
  const [subGroupCOA, setSubGroupCOA] = useState("");
  const [groupCOA, setGroupCOA] = useState("");
  const [jenisSaldo, setJenisSaldo] = useState("");
  const [kasBank, setKasBank] = useState("");
  const [bulan, setBulan] = useState("");
  const [COAsData, setCOAsData] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    { title: "No", field: "no" },
    { title: "Kode", field: "kodeCOA" },
    { title: "Nama COA", field: "namaCOA" },
    { title: "Jenis COA", field: "jenisCOA" },
    { title: "Sub Group COA", field: "subGroupCOA" },
    { title: "Group COA", field: "groupCOA" },
    { title: "Jenis Saldo", field: "jenisSaldo" },
    { title: "Kas/Bank", field: "kasBank" },
  ];

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    id ? getGroupCOAById() : setIsCOAExist(false);
  }, [id]);

  useEffect(() => {
    getCOAsData();
  }, [page, searchTerm]);

  const getCOAsData = async () => {
    setLoading(true);
    try {
      const allCOAs = await axios.post(
        `${tempUrl}/COAsForDocPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          id: user._id,
          token: user.token,
        }
      );
      setQuery(searchTerm);
      setCOAsData(allCOAs.data.COAs);
      setPage(allCOAs.data.page);
      setPages(allCOAs.data.totalPage);
      setRows(allCOAs.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getCOAsForDoc = async (isPdf, isExcel) => {
    setLoading(true);
    const allCOAsForDoc = await axios.post(`${tempUrl}/COAsForDocNoId`, {
      id: user._id,
      token: user.token,
    });
    setLoading(false);
    if (isPdf) {
      downloadPdf(allCOAsForDoc.data);
    } else if (isExcel) {
      downloadExcel(allCOAsForDoc.data);
    }
  };

  const getGroupCOAById = async () => {
    setLoading(true);
    if (id) {
      const pickedWilayah = await axios.post(`${tempUrl}/COAs/${id}`, {
        id: user._id,
        token: user.token,
      });
      setIsCOAExist(true);
      setKodeCOA(pickedWilayah.data.kodeCOA);
      setNamaCOA(pickedWilayah.data.namaCOA);
      setJenisCOA(pickedWilayah.data.jenisCOA);
      setSubGroupCOA(pickedWilayah.data.subGroupCOA);
      setGroupCOA(pickedWilayah.data.groupCOA);
      setJenisSaldo(pickedWilayah.data.jenisSaldo);
      setKasBank(pickedWilayah.data.kasBank);
    }
    setLoading(false);
  };

  const deleteCOA = async (id) => {
    try {
      let findCOARecord = await axios.post(`${tempUrl}/neracaSaldoAllRecord`, {
        kodeCOA,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      let findKasMasukCoa = await axios.post(`${tempUrl}/kasMasuksCoa`, {
        COAId: id,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      let findKasKeluarCoa = await axios.post(`${tempUrl}/kasKeluarsCoa`, {
        COAId: id,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      let findBankMasukCoa = await axios.post(`${tempUrl}/bankMasuksCoa`, {
        COAId: id,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      let findBankKeluarCoa = await axios.post(`${tempUrl}/bankKeluarsCoa`, {
        COAId: id,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      let findBiayaPerawatanCoa = await axios.post(
        `${tempUrl}/biayaPerawatansCoa`,
        {
          COAId: id,
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        }
      );
      let findCabangCoa = await axios.post(`${tempUrl}/cabangsCoa`, {
        COAId: id,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      let findJualCoa = await axios.post(`${tempUrl}/jualsCoa`, {
        COAId: id,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      let findPenerimaanCoa = await axios.post(`${tempUrl}/penerimaansCoa`, {
        COAId: id,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      let coaDataExist =
        findKasMasukCoa.data.length > 0 ||
        findKasKeluarCoa.data.length > 0 ||
        findBankMasukCoa.data.length > 0 ||
        findBankKeluarCoa.data.length > 0 ||
        findBiayaPerawatanCoa.data.length > 0 ||
        findCabangCoa.data.length > 0 ||
        findJualCoa.data.length > 0 ||
        findPenerimaanCoa.data.length > 0;
      if (findCOARecord.data.length > 0) {
        // There's Record -> Forbid Delete
        setBulan(findCOARecord.data[0].bulan);
        handleClickOpen();
      } else if (coaDataExist) {
        // There's Record -> Forbid Delete
        handleClickOpen();
      } else {
        // No Record Found -> Delete
        setLoading(true);
        await axios.post(`${tempUrl}/deleteCOA/${id}`, {
          id: user._id,
          token: user.token,
        });
        setKodeCOA("");
        setNamaCOA("");
        setSubGroupCOA("");
        setGroupCOA("");
        setJenisSaldo("");
        setKasBank("");
        setLoading(false);
        navigate("/COA");
        getCOAsData();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const downloadPdf = (data) => {
    var date = new Date();
    var current_date = formatDate(date);
    var current_time = formatTime(date);
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.lokasiPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Daftar COA`, 90, 30);
    doc.setFontSize(10);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.setFontSize(12);
    let no = 0;
    doc.autoTable({
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      columns: columns.map((col) => ({ ...col, dataKey: col.field })),
      body: data.map((col) => {
        no++;
        return { ...col, no };
      }),
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const downloadExcel = (data) => {
    const workSheet = XLSX.utils.json_to_sheet(data);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, `COA`);
    // Buffer
    let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    // Binary String
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    // Download
    XLSX.writeFile(workBook, `daftarCOA.xlsx`);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <ScrollToTop />
      <Typography color="#757575">Master</Typography>
      <Typography variant="h4" sx={subTitleText}>
        COA
      </Typography>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Tidak bisa dihapus karena sudah ada mutasi!`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`Periode Mutasi: ${bulan}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            startIcon={<PrintIcon />}
            onClick={() => getCOAsForDoc(true, false)}
          >
            CETAK
          </Button>
          <Button
            startIcon={<DownloadIcon />}
            onClick={() => getCOAsForDoc(false, true)}
          >
            EXCEL
          </Button>
        </ButtonGroup>
      </Box>
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={isCOAExist}
          addLink={`/COA/tambahCOA`}
          editLink={`/COA/${id}/edit`}
          deleteUser={deleteCOA}
          nameUser={kodeCOA}
        />
      </Box>
      <Divider sx={dividerStyle} />
      {isCOAExist && (
        <>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Kode COA :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={kodeCOA} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nama COA :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={namaCOA} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Jenis Saldo :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={jenisSaldo} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Kas/Bank :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={kasBank} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nama Jenis COA :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={jenisCOA} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Group COA :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={groupCOA} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Sub Group COA :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={subGroupCOA} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
          </Box>
          <Divider sx={dividerStyle} />
        </>
      )}
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableCOA currentPosts={COAsData} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilCOA;

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const spacingTop = {
  mt: 4,
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};
